export const getDummySubmitPledgeResponse = () => {
    return {
        body: {
            Message: "Success",
            Status: 0,
            dpid: 82500,
            pledgedtls: "4952iCgbh+Dx3GvfTPb/kKhKAkzPnaFpptvantvmqwWAfYhpFdg4ru9M76T3FwbofkOSSG4uTkJu8Hnii2NjJ9wgeMuOdcGYRdxVSp+7oc+Sc3Tq7vZCDkgSLpj0n3AwZbDOHezoio6Xfj3DscyMdzhHllb5CLZFMGoCrbtDuE+IINOHOSBaiTDpa1j6BMscWYkRS9WdXqy16RQvRTsky1eeSIMjPfTkDvnR7bRcHLr3I3YYTaZuFqsmI+lTl7TTb7lUIWvuSjbwae+i8lZXEPxb7BQomydS4UqWu8e2Xu7RveA0LTevRSg6m+ChyOmdcVgbVNzi3+OUT2PEQHP6IIVq2AM810K3JZqSH5J1OpX1Yh8FRvUZ52I81pbuGRXwiw8lIChFIShzXyy/uEngxX73d+l4w2IAUAJmi5sAgQgiCHqaurxc0ipyK4KLNpfT9IkrKaXQiaJHyZr/J+/peb3Uutf83N7rhXJqxA1SELk16SNwItB0o+Rfu0JX5xqQC4hqnsXNPC+vX2SZrCnrCVXEnpD+PLjzPwXzxcElSztjWij9GhW7tFU7S3ShDyuWuwLMTfXqfpd+GVc29gVkE1GezIHV/Hrthw2XvPqzL36rXWP+rs3gSb0Icy40LkC/HCS+0nacsS6J2Z1MYq+Afw+4ebXckS2pLBMsYeX+HINiPtu9Hf5tNUeJYBUXLx6aE1Z+P6tNl2cYiW9b/qwPTIX0wN78yt2zYMlMJDJL1+tSbt08LcSB5WVSXTlFInOVLrRiI2+w7ZOXYf/cbt95nTEeYeA2tlfy5PYnkcC8c1FUe+TbGOZTDSaeejdzGAL0PTI8WWVTu71ZEX+rBqlt7ZagXLQzGlaGIXzjCLbEwxKGPepMXZKfZNCEQ1s+o3gNWviwWkYaoD7U/Ygj1U+GUBVZhOWxJC5IQKUPFh9y9W3yBveuI3P2DI+9d7IKCUebVwFb6XoFFO0i2uQ0yBbwS1ie9VhkCWfgIav+KmuDVH8=",
            posturl: "https://api.cdslindia.com/APIServices/pledgeapi/pledgesetup",
            reqid: "2306202300478920",
            version: "1.0",
        },
        head: {
            responseCode: "5PPostDataToCDSLMP",
            status: "0",
            statusDescription: "Success",
        },
    };
};
